import { Component, Input } from '@angular/core'
import { IonButton, IonIcon, ModalController } from '@ionic/angular/standalone'
import { TranslatePipe } from '@ngx-translate/core'
import { addIcons } from 'ionicons'
import { closeOutline } from 'ionicons/icons'

@Component({
	selector: 'app-casino-disabled-modal',
	templateUrl: './casino-disabled-modal.component.html',
	standalone: true,
	imports: [IonIcon, IonButton, TranslatePipe],
})
export class CasinoDisabledModalComponent {
	@Input() message = 'Casino Unavailable'

	constructor(private readonly modalController: ModalController) {
		addIcons({ closeOutline })
	}

	dismiss() {
		void this.modalController.dismiss()
	}
}
